import { animated } from "@react-spring/web";
import styled from "styled-components";

export default animated(styled.div`
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing(3)}px 0`};
`);
